
<main>
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center" [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="onTabChanged($event)">
        <mat-tab label="Open">
            <div class="main-members family-tabs">
                <a *ngFor="let member of openContactUsList" class="member-list-item">
                    <div>
                        <h5>{{ member.person_name }}</h5>
                        <p>{{ member.contact_number }} </p>
                        <p>{{ member.description }} </p>
                    </div>
                    <mat-slide-toggle [(ngModel)]="member.is_active" class="example-margin" 
                    [color]="member.is_active == 1? 'green' : 'red' " (change)="openDialog($event,member)"></mat-slide-toggle>
                </a>
            </div>
        </mat-tab>

        <mat-tab label="Closed">
            <div class="main-members family-tabs">
                <a *ngFor="let member of closeContactUsList" class="member-list-item">
                    <div>
                        <h5>{{ member.person_name }}</h5>
                        <p>{{ member.contact_number }} </p>
                        <p>{{ member.description }} </p>
                    </div>
                    <mat-slide-toggle [(ngModel)]="member.is_active" class="example-margin" 
                    [color]="member.is_active == 1? 'green' : 'red' " (change)="openDialog($event,member)"></mat-slide-toggle>
                </a>
            </div>
        </mat-tab>
    </mat-tab-group>
    <!-- <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
        <mat-tab label="સંપર્ક વિગતો">
            <div class="main-members family-tabs">
                <a *ngFor="let member of contactUsList" class="member-list-item">
                    <div>
                        <h5>{{ member.person_name }}</h5>
                        <p>{{ member.contact_number }} </p>
                        <p>{{ member.description }} </p>
                    </div>
                    <mat-slide-toggle [(ngModel)]="member.is_active" class="example-margin" 
                    [color]="member.is_active == 1? 'green' : 'red' " (change)="openDialog($event,member)"></mat-slide-toggle>
                </a>
            </div>
        </mat-tab>
    </mat-tab-group> -->
</main>